export default "__VITE_ASSET__BJVQCgSe__"